import React from 'react'
import { useParams } from 'react-router-dom';

const ServicesDetails = () => {
  const { serviceId } = useParams();

  return (
        // <p className="base_heading_2">

    <div className='base_heading_2'>ServicesDetails - { serviceId }</div>
  )
}

export default ServicesDetails